// extracted by mini-css-extract-plugin
export default {"right":"price_right__xofNw","left":"price_left__X0u8k","center":"price_center__kI3GR","inline":"price_inline__OUEEX"};